
import { Vue, Component } from "vue-property-decorator";
import Intro from "@/components/feedback/performance/Intro.vue";
import Headline from "@/components/feedback/performance/Headline.vue";
import Examples from "@/components/feedback/performance/Examples.vue";
import ExamplesFirst from "@/components/feedback/performance/ExamplesFirst.vue";
import ExampleCarrousel from "@/components/feedback/performance/ExampleCarrousel.vue";
import ExamplesSuite from "@/components/feedback/performance/ExamplesSuite.vue";
import ResTitle from "@/components/feedback/performance/ResTitle.vue";
import BlankGraph from "@/components/feedback/performance/BlankGraph.vue";
import IndivResults from "@/components/feedback/performance/IndivResults.vue";
import GroupResults from "@/components/feedback/performance/GroupResults.vue";
import Conclusion from "@/components/feedback/performance/Conclusion.vue";

import OneByOneComponentRenderer from "@/components/OneByOneComponentRenderer.vue";
import { mapState } from "vuex";
import { FeedbackType } from "@/schemas/Enums";

@Component({
  name: "PerformanceFeedback",
  components: {
    OneByOneComponentRenderer,
  },
  computed: {
    ...mapState("session", ["session"]),
  },
  emits: ["displayRedirect", "displayFeedbackEndButton"],
})
export default class PerformanceFeedback extends Vue {
  feedbackComponents = [
    Intro,
    Headline,
    Examples,
    ExamplesSuite,
    [IndivResults, GroupResults],
  ]; //    Conclusion,
  feedbackComponentsAvg = [
    Intro,
    [ResTitle, BlankGraph, IndivResults, GroupResults],
    Headline,
    ExampleCarrousel,
  ];
  // La fonction d'après sert a savoir si c'est le vieux FB ou le nouveau en moyenne, et atm on force que ce soit toujours en moyenne, pour tout le monde, même si la BDD dit le contraire
  get displayAvgFeedback(): boolean {
    // if (this.session.setting) {
    //   let settings = this.session.setting.feedback_details.find(
    //     (setting: {
    //       type: FeedbackType;
    //       display_feedback_message: boolean;
    //       display_score?: boolean;
    //       display_indiv_scores?: boolean;
    //       display_group_score?: boolean;
    //       display_avg_feedback?: boolean;
    //     }) => setting.type === FeedbackType.Performance
    //   );
    //   return settings ? settings.display_avg_feedback : false;
    // }
    // return false;
    return true;
  }
}
